import parse from 'html-react-parser';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './helpCenterListItem.module.scss';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function HelpCenterListItem({
  headline = '',
  description = '',
  link = '',
  subProducts = [],
  subProductsPosition = 'left',
  subProductsAlignment = 'inline',
  icon = null,
  iconPosition = 'left',
  moduleType = 'list',
}) {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);
  const itemClassName = iconPosition === 'top' ? styles.itemPosition : '';
  const itemAlignClassName =
    subProductsPosition === 'right'
      ? `${styles.itemAlign} ${styles.subProductPosition}`
      : '';
  const subProductAlignmentClass =
    subProductsAlignment === 'inline' ? styles.subAlignment : '';
  const titleClassName = moduleType === 'box' ? styles.titleBox : '';

  return (
    <div
      className={`${styles.item} ${!isMobile && itemClassName} ${
        !isMobile && itemAlignClassName
      }`}
      key={`item-${headline}`}
    >
      {icon && (
        <div className={styles.icon}>
          <img
            src={icon.path}
            loading="lazy"
            alt={icon.alt}
            {...{
              ...(icon.width && {
                width: icon.width,
              }),
              ...(icon.height && {
                height: icon.height,
              }),
            }}
          />
        </div>
      )}
      <div className={`${styles.content} ${!isMobile && itemAlignClassName}`}>
        <h3 className={`${styles.title} ${titleClassName}`}>
          {link ? (
            <Link href={link} className={styles.itemLink}>
              {parse(headline)}
            </Link>
          ) : (
            parse(headline)
          )}
        </h3>
        {description && (
          <div className={styles.description}>{parse(description)}</div>
        )}
        {subProducts && (
          <ul
            className={`${styles.subProduct} ${
              !isMobile && subProductAlignmentClass
            }`}
          >
            {subProducts.map((item) => {
              return (
                <li key={`${item.label}`}>
                  {item.link ? (
                    <Link href={item.link}>{item.label}</Link>
                  ) : (
                    item.label
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

HelpCenterListItem.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  subProducts: PropTypes.array,
  subProductsPosition: PropTypes.string,
  subProductsAlignment: PropTypes.string,
  icon: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
  }),
  iconPosition: PropTypes.string,
  moduleType: PropTypes.string,
};
